// extracted by mini-css-extract-plugin
export var masonryGrid = "Publications-module--masonry-grid--P2GU7";
export var masonryGridColumn = "Publications-module--masonry-grid-column--MNPtz";
export var link = "Publications-module--link--aiJV5";